// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__4KO5X","container":"styles_container__NADxM","title":"styles_title__2wsuE","wrapper":"styles_wrapper__1e5Tl","answer":"styles_answer__1Dhtl"};